import styled from 'styled-components';
import { asRem } from 'utils';
import { breakpoints, colors } from 'Theme';

export default styled.div`
  &.webplayer--zpp-course {
    .player-container {
      .player-list-item-content:hover {
        background-color: ${colors.white.c500};
        cursor: default;
      }
      .player-container-gradient {
        width: 100%;
        height: 40px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: linear-gradient(to bottom, transparent, ${({ backgroundColor }) => backgroundColor});
      }
      & > div {
        position: relative;

        .player {
          padding-top: ${asRem(8)};

          @media (min-width: ${breakpoints.lg}) {
            padding-top: ${asRem(42)};
          }
        }
      }
    }
  }

  .zpp-course-remove-teaser {
    left: ${asRem(16)};
    right: ${asRem(16)};
    width: calc(100% - ${asRem(32)});

    @media (min-width: ${breakpoints.lg}) {
      left: 0;
      right: 0;
      width: 100%;
    }
  }

  .teaser-container {
    .zpp-course-remove-teaser {
        left: 0;
        right: 0;
        width: 100%;
      }
    }
  }
`;
